var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfile = function SvgProfile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10 10.876A3.938 3.938 0 1 0 10.003 3 3.938 3.938 0 0 0 10 10.876m3.5.875h-1.506a4.76 4.76 0 0 1-3.988 0H6.5a3.5 3.5 0 0 0-3.5 3.5v.437a1.313 1.313 0 0 0 1.313 1.313h11.375A1.314 1.314 0 0 0 17 15.69v-.439a3.5 3.5 0 0 0-3.5-3.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export default ForwardRef;